module.exports = __webpack_public_path__ + "img/34_ancillary.e0b64f9f.jpg";